import React from "react"
import { TypeAnimation } from "react-type-animation"
import colorSupport from "supports-color"

console.log(colorSupport)

const Home = () => {
  return (
    <div
      id="home"
      className="section container mx-auto max-w-[1200px] px-4 py-10 items-center"
      style={{ paddingTop: "300px", paddingBottom: "100px" }}
    >
      <div className="w-full">
        {/* Logo Center */}
        <div className="flex justify-center mb-8 relative z-10">
          <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-primary shadow-lg bg-white relative z-20">
            <img
              src="/images/Cakra Digital Innovation.png"
              alt="Cakra Digital Innovation Logo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        
        <div className="block text-center font-secondary font-black text-[36px] mb-6">Tentang Cakra Digital Innovation</div>
        
        <div className="text-center mb-8">
          <TypeAnimation
            sequence={["Creative Digital Agency", 3000, "Website Development", 3000, "Digital Marketing", 3000, "SEO & Advertising", 3000, "One Stop Digital Solution", 3000]}
            wrapper="span"
            speed={50}
            style={{ fontSize: "2em", display: "inline-block" }}
            repeat={Infinity}
            className="text-secondary"
          />
        </div>
        
        <div className="font-gradient flex mx-auto mt-5 text-center text-[18px] max-w-[800px] mb-8">
          Cakra Digital Innovation adalah Creative Digital Agency yang berfokus membantu UMKM dan bisnis berkembang melalui solusi digital yang terstruktur, modern, dan berbasis hasil.
        </div>
        
        <div className="font-normal text-center text-[16px] max-w-[900px] mx-auto mb-8 text-gray-700">
          Kami menghadirkan layanan terintegrasi mulai dari Website Development (React JS & Modern Stack), SEO, Digital Advertising (Google & Meta Ads), hingga Pengembangan Aplikasi. Dengan pendekatan berbasis data dan strategi yang terukur, setiap project dirancang bukan hanya untuk tampil profesional — tetapi juga menghasilkan traffic, leads, dan konversi nyata.
        </div>
        
        <div className="font-normal text-center text-[16px] max-w-[900px] mx-auto mb-8 text-gray-700">
          Sebagai usaha resmi terdaftar dengan NIB 1502260008495 (KBLI 62090 – Aktivitas Teknologi Informasi dan Jasa Komputer Lainnya), kami berkomitmen menjalankan bisnis secara profesional, legal, dan berkelanjutan.
        </div>
        
        {/* Visi & Misi Section */}
        <div className="max-w-4xl mx-auto mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Visi */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 shadow-sm border border-blue-100">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-800">Visi</h3>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                Menjadi Creative Digital Agency terpercaya yang membantu bisnis bertumbuh secara terukur melalui teknologi, strategi digital, dan inovasi kreatif.
              </p>
            </div>
            
            {/* Misi */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6 shadow-sm border border-green-100">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-gray-800">Misi</h3>
              </div>
              <ul className="text-sm text-gray-700 leading-relaxed space-y-2">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1">•</span>
                  <span>Solusi digital terintegrasi (Website, SEO, Ads, Aplikasi)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1">•</span>
                  <span>Strategi pemasaran berbasis data dan hasil terukur</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1">•</span>
                  <span>Meningkatkan traffic, leads, dan konversi konsisten</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1">•</span>
                  <span>Membangun sistem digital yang scalable dan berkelanjutan</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1">•</span>
                  <span>Mengedukasi tentang pentingnya ekosistem digital sehat</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
